import React from 'react';
import { ChevronDown } from 'lucide-react';
import { NAV_SECTIONS, COLLECTIONS } from '../data/siteContent';

export const DesktopLinks = ({ onNavigate, isCollectionsOpen, setIsCollectionsOpen, linkClass = 'text-[#001B2A]', collections = COLLECTIONS }) => (
  <div className="hidden md:flex items-center space-x-8">
    <button
      onClick={() => onNavigate('home')}
      className={`text-sm font-medium ${linkClass} hover:text-[#7B1E2B] transition-colors`}
    >
      HOME
    </button>

    <div
      className="relative"
      onMouseEnter={() => setIsCollectionsOpen(true)}
      onMouseLeave={() => setIsCollectionsOpen(false)}
    >
      <button className={`flex items-center text-sm font-medium ${linkClass} hover:text-[#7B1E2B] transition-colors`}>
        COLLECTIONS
        <ChevronDown className="ml-1 h-4 w-4" />
      </button>

      {isCollectionsOpen && (
        <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md overflow-hidden">
          {collections.map((c) => (
            <button
              key={c.id}
              onClick={() => onNavigate(c.id)}
              className="block w-full text-left px-4 py-3 text-sm text-[#001B2A] hover:bg-[#F5F5F5] transition-colors"
            >
              {c.label}
            </button>
          ))}
        </div>
      )}
    </div>

    {NAV_SECTIONS.map((s) => (
      <button
        key={s.id}
        onClick={() => onNavigate(s.id)}
        className={`text-sm font-medium ${linkClass} hover:text-[#7B1E2B] transition-colors`}
      >
        {s.label}
      </button>
    ))}
  </div>
);

export const MobileMenu = ({ onNavigate, collections = COLLECTIONS }) => (
  <div className="md:hidden bg-white border-t border-gray-200">
    <div className="px-4 py-3 space-y-3">
      <button
        onClick={() => onNavigate('home')}
        className="block w-full text-left py-2 text-sm font-medium text-[#001B2A] hover:text-[#7B1E2B] transition-colors"
      >
        HOME
      </button>

      <div className="space-y-2">
        <div className="text-sm font-medium text-[#001B2A] py-2">COLLECTIONS</div>
        {collections.map((c) => (
          <button
            key={c.id}
            onClick={() => onNavigate(c.id)}
            className="block w-full text-left pl-4 py-2 text-sm text-[#2F2F2F] hover:text-[#7B1E2B] transition-colors"
          >
            {c.label}
          </button>
        ))}
      </div>

      {NAV_SECTIONS.map((s) => (
        <button
          key={s.id}
          onClick={() => onNavigate(s.id)}
          className="block w-full text-left py-2 text-sm font-medium text-[#001B2A] hover:text-[#7B1E2B] transition-colors"
        >
          {s.label}
        </button>
      ))}
    </div>
  </div>
);
